<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuth } from '@/composables/useAuth'

const { checkAuth } = useAuth()

onMounted(async () => {
  await checkAuth()
})
</script>